// Toasts and translated error messages next to the action that failed (SPEC §9.4, §8.3).

import type { Problem } from "../api/types";
import { t, translateCode } from "../i18n/i18n";
import { createElement } from "./dom";

const TOAST_MILLISECONDS: number = 3500;

/** A short non-blocking message at the bottom of the screen. */
export function showToast(message: string): void {
  const region: HTMLElement = ensureToastRegion();
  const toast: HTMLDivElement = createElement("div", "toast", message);
  toast.setAttribute("role", "status");
  region.append(toast);
  window.setTimeout((): void => {
    toast.remove();
  }, TOAST_MILLISECONDS);
}

/** The translated top-level message of a problem. */
export function describeProblem(problem: Problem): string {
  if (problem.code === "NETWORK") {
    return t("app.networkError");
  }

  return translateCode("errors", problem.code, problem.params);
}

/** An inline error box; empty and hidden until a problem is shown. */
export function createErrorBox(): HTMLDivElement {
  const box: HTMLDivElement = createElement("div", "error-box");
  box.setAttribute("role", "alert");
  box.hidden = true;
  return box;
}

/** Shows the problem's message in the box, or hides it when null. */
export function showProblem(box: HTMLElement, problem: Problem | null): void {
  if (problem === null) {
    box.hidden = true;
    box.replaceChildren();
    return;
  }

  box.hidden = false;
  box.replaceChildren(createElement("span", "", describeProblem(problem)));
}

function ensureToastRegion(): HTMLElement {
  const existing: HTMLElement | null = document.getElementById("toasts");
  if (existing !== null) {
    return existing;
  }

  const region: HTMLDivElement = createElement("div", "toast-region");
  region.id = "toasts";
  document.body.append(region);
  return region;
}
